import { useQuery } from '@apollo/react-hooks';
import { Box, Grid, FormControlLabel, Switch as MUISwitch } from '@material-ui/core';
import gql from 'graphql-tag';
import React, { useEffect } from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import MainPage from '../MainPage';
import ParticipantDetail from '../ParticipantDetail';
import ErrorHandling from '../ErrorHandling';
import ServiceDetail from '../ServiceDetail';
import { DispatchContext, StateContext } from '../../App';
import reducer from '../reducer';
import BreadCrumb from '../../Breadcrumb';
import UserProfile from '../UserProfile';
import { Loading } from '../../Loading';

const Query = gql`
  query {
    workflow @rest(method: "GET", type: "workflow", path: "api/v1/broker/workflow") {
      content
      pageable
    }
  }
`;

const USER_DETAIL = gql`
  query {
    userProfileMe @rest(method: "GET", type: "userProfile", path: "api/v1/broker/user/me") {
      tid
      userName
      roles
      participantRoleInfos
      userInfo
    }
  }
`;

type workflowObj = {
  content: any;
};

const App = () => {
  useQuery<workflowObj, {}>(Query, {});
  const { data: userData, loading } = useQuery(USER_DETAIL, { fetchPolicy: 'network-only' });
  const [state, dispatch] = React.useReducer(reducer, {});

  const [userRole, setUserRole] = React.useState('');
  const [participantCode, setParticipantCode] = React.useState('');
  // const [updateED, setUpdateED] = React.useState<boolean>(false);

  useEffect(() => {
    setUserRole(userData?.userProfile?.roles?.[0]);
    setParticipantCode(userData?.userProfile?.participantRoleInfos?.[0]?.participant?.participantCode);
  }, [userData]);

  // const handleErrorToggleChange = () => {
  //   setUpdateED(!updateED);
  //   if (updateED === false) sessionStorage.setItem('enableED', 'true');
  //   else sessionStorage.setItem('enableED', 'false');
  // };
  return (
    <>
      {loading ? (
        <Loading />
      ) : (
        <>
          <DispatchContext.Provider value={dispatch}>
            <StateContext.Provider value={state}>
              <Box overflow="hidden" width="100%">
                <Grid container style={{ width: '100%' }}>
                  <Grid item xs={10}>
                    <BreadCrumb />
                  </Grid>
                  {/* <Grid item xs={1} style={{ backgroundColor: 'white', borderRadius: '18px' }}>
                    <FormControlLabel
                      control={<MUISwitch color="primary" checked={updateED} />}
                      label="ED V1.0"
                      onChange={handleErrorToggleChange}
                      style={{ marginLeft: '20px' }}
                    />
                  </Grid> */}
                  <Grid item xs={2}>
                    <UserProfile />
                  </Grid>
                </Grid>
                <Switch>
                  <Route exact path="/:tab" component={MainPage} />
                  {(userRole === 'PARTICIPANT_SUPPORT' || userRole === 'PARTICIPANT_ADMIN') && (
                    <Route exact path="/dashboard" component={MainPage} />
                  )}
                  <Route exact path="/participant/:code/:detailTab" component={ParticipantDetail} />
                  <Route exact path="/participant/:code/:detailTab/:workflowCode" component={ParticipantDetail} />
                  <Route
                    exact
                    path="/participant/:code/:detailTab/:workflowCode/:serviceTab"
                    component={ParticipantDetail}
                  />
                  <Route exact path="/participant/:code" component={ParticipantDetail} />
                  <Route exact path="/service/:workflowCode" component={ServiceDetail} />
                  <Route exact path="/service/:workflowCode/:detailTab" component={ServiceDetail} />{' '}
                  <Redirect path="/" to="/participant" />
                </Switch>
                <ErrorHandling />
              </Box>
            </StateContext.Provider>
          </DispatchContext.Provider>
        </>
      )}
    </>
  );
};

export default App;
